module.exports = __webpack_public_path__ + "static/media/fam_desc1.9c7b1a58.png";